import React, { useState } from 'react';

const sanitizeInput = (input) => {
  if (typeof input !== 'string') return input;
  return input.replace(/[<>&"']/g, (match) => ({
    '<': '&lt;',
    '>': '&gt;',
    '&': '&amp;',
    '"': '&quot;',
    "'": '&#x27;',
  }[match]));
};

function Quests({ activeQuests, setPlayer, setGameLog }) {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <div className="quests-panel">
      <div className="panel-header">
        <h4>Active Quests</h4>
        <button className="collapse-toggle" onClick={() => setIsCollapsed(!isCollapsed)}>
          {isCollapsed ? 'Expand' : 'Collapse'}
        </button>
      </div>
      {!isCollapsed && (
        <>
          {activeQuests.length === 0 ? (
            <p>No active quests.</p>
          ) : (
            <ul className="quest-list">
              {activeQuests.map((quest) => {
                const progress = Math.max(0, quest.progress || 0);
                const objectiveCount = Math.max(1, quest.objective_count);
                const progressPercentage = (progress / objectiveCount) * 100;

                return (
                  <li key={quest.id} className="quest-item">
                    <div className="quest-header">
                      <strong>{sanitizeInput(quest.title)}</strong>
                      {progress >= objectiveCount && (
                        <span className="quest-completed"> (Completed)</span>
                      )}
                    </div>
                    <p className="quest-description">{sanitizeInput(quest.description)}</p>
                    <div className="quest-progress">
                      <p>
                        Progress: {progress}/{objectiveCount}{' '}
                        {quest.objective_type === 'kill'
                          ? sanitizeInput(quest.objective_target)
                          : quest.objective_type === 'collect'
                          ? sanitizeInput(quest.objective_target)
                          : quest.objective_type === 'explore'
                          ? `in ${sanitizeInput(quest.objective_target)}`
                          : quest.objective_type === 'find'
                          ? sanitizeInput(quest.objective_target)
                          : ''}
                      </p>
                      <progress
                        value={progress}
                        max={objectiveCount}
                        className="quest-progress-bar"
                      />
                    </div>
                    {progress >= objectiveCount && (
                      <p className="quest-reward">Reward claimed automatically!</p>
                    )}
                  </li>
                );
              })}
            </ul>
          )}
        </>
      )}
    </div>
  );
}

export default Quests;